import Modal from './modal';
import {
  EmbedStates,
  LAZYLOAD_CLASS
} from '../constants';
import {
  showLog,
  showWarn,
  showError
} from '../logger';

const POSTER_TEMPLATE = `
<img class="${LAZYLOAD_CLASS}" data-original="{poster}" width="100%" height="auto" />
<noscript>
  <img src="{poster}" width="100%" height="auto" />
</noscript>
`;

class EmbedView {
  constructor({metadata, player, container$}) {
    this.metadata   = metadata;
    this.player     = player;
    this.container$ = container$;
    this.state      = EmbedStates.EMPTY;
  }

  fetch() {
    this.container$.on('inview', (event, isInView) => {
      if (isInView) {
        // ISINVIEW
        showLog('view.js::render::isInView');
        let isViewEmpty = this.state !== EmbedStates.WITH_POSTER && this.state !== EmbedStates.WITH_PLAYER;
        if (isViewEmpty) {
          return this.metadata.fetch()
            .then((metadata) => { this.metadata.metadata = metadata; })
            .then(() => this.container$.attr('data-voc-video-player-processed', 'true'))
            .then(() => this.render());
        }
        let video$ = this.container$.children().find('video').get(0);
        // play video after ad
        return setTimeout(()  => {
          if (video$
            && typeof videojs !== 'undefined'
            && videojs(video$.id)
            && videojs(video$.id).ima3
            && videojs(video$.id).ima3.adsManager) {
            videojs(video$.id).one('playing', () => {
              videojs(video$.id).play();
            });
          }
        }, 0);
      }
      // NOT ISINVIEW
      showLog('view.js::render::NOT-isInView');
      let video$ = this.container$.children().find('video').get(0);
      // pause video
      if (video$ && !video$.paused) {
        videojs(video$.id).pause();
        return video$.pause();
      }
      // pause video after ad
      return setTimeout(()  => {
        if (video$
          && typeof videojs !== 'undefined'
          && videojs(video$.id)
          && videojs(video$.id).ima3
          && videojs(video$.id).ima3.adsManager) {
          videojs(video$.id).one('playing', () => {
            videojs(video$.id).pause();
          });
        }
      }, 0);
    });
  }

  render() {
    if (this.player.options.autoplay && !this.player.options.modallayer) {
      this.isPlayerRendered();
    } else {
      this.isPosterRendered();
    }
  }
  renderPoster() {
    if (!this.player.options.poster) {
      this.player.options.poster = this.metadata.metadata.poster;
    }
    this.container$.append(POSTER_TEMPLATE.replace(/{poster}/g, this.player.options.poster));
    setTimeout(() => this.container$.find(`.${LAZYLOAD_CLASS}`).lazyload(), 0);
    this.bindPosterEvents();
    this.state = EmbedStates.WITH_POSTER;
  }

  renderPlayer() {
    Voonto.is.desktop() ?
      this.player.options.autoplay = true : this.player.options.autoplay = false;
    if (this.player.options.modallayer) {
      this.renderModal();
    } else {
      this.renderEmbed();
    }
    this.state = EmbedStates.WITH_PLAYER;
  }

  renderEmbed() {
    this.container$.off('click');
    this.player.fetch().then((player) => { this.container$.html(player); });
  }

  renderModal() {
    this.container$.off('click');
    let modal = new Modal(this.player, this.metadata.metadata);
    modal.fetch().then(() => { this.container$.on('click', () => this.renderPlayer()); });
  }

  bindPosterEvents() {
    this.container$.on('click', () => this.renderPlayer());
  }

  isPosterRendered() {
    if (this.state !== EmbedStates.WITH_POSTER && this.state !== EmbedStates.WITH_PLAYER) { this.renderPoster(); }
  }

  isPlayerRendered() {
    if (this.state !== EmbedStates.WITH_PLAYER) { this.renderPlayer(); }
  }
}

export default EmbedView;



// WEBPACK FOOTER //
// ./src/views/embed.js